import { InfiniteData } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router';

export type InferRouteData<T extends { execute: (input?: any) => Promise<any> }> = Awaited<ReturnType<T['execute']>>;
export type InferData<T extends InfiniteData<any, any> | undefined> = T extends InfiniteData<any, any> ? T['pages'][number]['rows'][number] : never;
export const ITEMS_PER_PAGE = 10;

export const nextPageParamFn = (lastPage: InferRouteData<any>, allPages: InferRouteData<any>[]) => {
	if (lastPage?.rows == null) {
		return 0;
	}

	if (lastPage.rows.length < ITEMS_PER_PAGE) {
		return undefined;
	}
	return allPages.length * ITEMS_PER_PAGE;
};

export const useTableData = <T extends InfiniteData<any, any> | undefined>(data: T) => {
	return useMemo(() => data?.pages.flatMap(page => page.rows) ?? [], [data]);
};

export function useNumberParam(paramName: string): number | undefined {
	const params = useParams();
	const value = params[paramName];
	const num = Number(value);

	return isNaN(num) ? undefined : num;
}

export function useNumberQueryParam(paramName: string): number | undefined {
	const [params] = useSearchParams();
	const value = params.get(paramName);
	const num = Number(value);

	return isNaN(num) ? undefined : num;
}
